
jQuery(document).ready(function($) {
var getElem = setInterval(function () {

    // Look for the element in the DOM
    var elem = document.querySelector('.stl__products_container');
    let slideToShow = 2;
    if($('.stl__products_container').find('.ctl-product-component').length == 1){
        slideToShow = 1
    }
    // If the element is in the DOM, stop the interval and do something
    if (elem) {
        clearInterval(getElem);
        // Do something else...
            // $(".stl__products_container").slick({
            //     infinite: false,
            //     slidesToShow: slideToShow,
            //     slidesToScroll: 1,
            //     arrows: false,
            //     dots: false,
            //     autoplay: false,
            //     fade: false,
            //     responsive: [{
            //         breakpoint: 767,
            //         settings: {
            //             infinite: false,
            //           slidesToShow: 1.38,
            //         }
            //       }
            //     ]
            // });

        $('.product--detail .ctl-product-title').matchHeight({
            byRow: true,
        });

      // change titles for shop the look
        $('.product--detail p.ctl-product-title > a').each((i, elm) => {
            let title = $(elm).text();
            let title_split = title.split(' - ');
            $(elm).html(`<strong>${title_split[0]}</strong> ${title_split[1]}`);
        })
        $('.ctl-product-component-info .ctl-product-price span').each((i, elm) => {
            let price = $(elm).text();
            let new_price = price.replaceAll(',00', '');
            $(elm).text(new_price);
        })
        if ($(window).width() < 749) {
            $('.shopthelook_variants option').each(function(i, e) {
                let text = $(e).text();
                let text_split = text.split(' / ');
                text_split.length > 0 ? $(e).text(text_split[1].replace('- Sold out','')) : null;
                console.log(e, 'e')
            })
        }
    }

}, 1000);

const ShopTheLook = setInterval(function(){
    if($(".shopthelook_variants").length > 0){
       $('.shopthelook_variants').each(function(i, e) {
        let __this = $(this);
           $(this).find("option").each(function(i, e) { // get the options
               let name = __this.attr('name');
               let data_price =  $(this).attr('data-price');
               let data_formatted_price = $(this).attr('data-formatted-price');
               let radioValue = $(this).text().split('/');
               let disabled = false;
               if($(this).hasClass('stl-disabled-option')){
                disabled = true;
               }
               $("<input type='radio' />")// create a radio element
                   .attr("value", $(this).val()) // set the value
                   .attr("id", $(this).val())
                   .attr("checked", i == 0) // check the first by default
                   .attr("name",name)
                   .attr("data-price",data_price)
                   .attr('data-formatted-price',data_formatted_price)
                   .prop('disabled',disabled)
                   .click(function () { // add event click which updates the dropdown
                       $($(this)).val($(this).val()); // update the dropdown if clicked
                   })
                   .appendTo(__this.parent()); // append to some visible place
                
                const newLabel = $("<label  />") // create a label
                .attr("for", $(this).val()) // add for value as
                .text(radioValue[1]?.replace('- Sold out','')) // add text for the label

                if(disabled) {
                    newLabel.addClass('stl-disabled-label');
                }

                newLabel.appendTo(__this.parent()); // append to some visible place
           });
       })
        clearInterval(ShopTheLook)
    }
},1000)

const radioInterval = setInterval(function(){
    if($('.selectize-control').length > 0){
        var preSelectVariant = $('[name="pre-select-variant"]').val();
        if(parseInt(preSelectVariant) != NaN){
            var currentSize = parseInt(preSelectVariant);
        }
        var selectedLabels = $('.product--detail .ctl-product-component .select-size-wrap label:contains('+currentSize+')')
        $('.selectize-control').each(function(i,e){
            $(this).find('input').each(function(i,e){
                if(i == 0){
                    $(this).trigger('click')
                }
            })
        })
        if(selectedLabels.length > 0) {
            selectedLabels.each(function(i, e) {
                $(this).prev('input').trigger('click');
            })
        }
        clearInterval(radioInterval)
    }
},1000)
$(document).on('change','.selectize-control input',function(){
    let currentVal = $(this).val();
    $('.shopthelook_variants option').removeProp();
    $('.shopthelook_variants option').each(function(i, e) {
        if(currentVal == $(this).val()){
            $(this).prop('selected', true).trigger('change');
        }
    })
})


});

$(document).ready(function() {

    let display_count = 0;

    function colorSelectTemplate(state) {
        console.log("1",state);
        if(display_count > 0) {
            window.location.href = state.text.split('||')[1];
        } else {
            display_count++;
        }

        return $(`<span style="background: ${state.text.split('||')[0]};" class="product-form__colorBox"></span>`)
    }

    function colorResultTemplate(state) {
        console.log("1",state)
        const stateArr = state.text.split('||');
        const link = stateArr[1];
        const text = stateArr[0];
        return $(`<a href="${link}" style="background: ${text};" class="product-form__colorBox"></a>`)
    }

    $('#product-color-select').select2({
        width: '57px',
        templateResult: colorResultTemplate,
        templateSelection: colorSelectTemplate
    })

    function sizeSelectTemplate(state) {
        const stateArr = state.text.split('||');
        const className = stateArr[1];
        const text = stateArr[0];
        return $(`<span class="${className}">${text}</span>`)
    }
    $('#product-size-select').select2({
        width: '57px',
        dropdownCssClass: 'select-size-dropdown',
        templateResult: sizeSelectTemplate,
        templateSelection: sizeSelectTemplate
    });

    $(document).on('change','#product-size-select',function(){
        let dropDownSelectValue = $(this).val();
        $('.product-form__input input[type="radio"]').each(function(){
            if($(this).val() == dropDownSelectValue){
                $(this).click()
            }
        })
      })
    window.addEventListener('scroll', function() {
        $('#product-color-select').select2('close');
        $('#product-size-select').select2('close');
    });


    var sizeChartInterval = setInterval(function(){
        if($('.sizing-chart-container').length > 0 ){
            var getHeight = $('.product__title_wrapper').outerHeight();
            console.log(getHeight);
            let top = getHeight+10
            $('.sizing-chart-container').css("top", top+"px");
            clearInterval(sizeChartInterval);
        }
    },10) 

})